import { r as registerInstance, h, F as Fragment, g as getElement, H as Host, c as createEvent } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import { s as scrollToComponent } from './lookups-705fb53e.js';
import { p as parseCommonURLToRouterParts } from './url-parser-fe899a81.js';
import { o as ETabType, F as DESKTOP_MAX_CONTENT_WIDTH } from './request.constants-deb285e0.js';
import { n as navigateWithRouter, i as isAppRoutingEnabled } from './utils-60b2d521.js';
import { P as PesRoute } from './pes-route-63457678.js';
import { a as getProductInfoFromBreadcrumbs } from './utils-400179ea.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import { E as ECarouselRelation } from './types-8e186e36.js';
import { s as setStickyBarTab, o as observeIntersectionWithHeader, a as setTabActive } from './stickyBar.utils-09e3b4ce.js';
import './utils-15ad90ec.js';
import './isObject-33fa1780.js';
import './_commonjsHelpers-ba3f0406.js';
import './analytics-765d4daf.js';
import './pes-router-store-1a105b49.js';
import './index-634d378a.js';
import './ResizeObserver-f193871f.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';

const breadcrumbsCss = ":host{display:block}.breadcrumbs{box-sizing:border-box;padding:14px 16px 10px}.breadcrumbs--hide-mobile{display:none}@media screen and (min-width: 980px){.breadcrumbs{display:block;max-width:1200px;margin-left:auto;margin-right:auto;padding:8px 10px;background-color:transparent}}.highlight-naming .accent{font-weight:bold}";

let Breadcrumbs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.hideOnMobile = false;
    this.tail = [];
    this.makeDidNavigateHandler = (route) => {
      return (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        navigateWithRouter(route, target);
      };
    };
    this.getBreadcrumb = (breadcrumb) => {
      let breadcrumbProps = {};
      if (breadcrumb.url) {
        if (isAppRoutingEnabled()) {
          const { pageType, pageId } = parseCommonURLToRouterParts(breadcrumb.url);
          const route = new PesRoute({ page: pageType, pageId });
          breadcrumbProps = { href: route.url, onDidNavigate: this.makeDidNavigateHandler(route) };
        }
        else {
          breadcrumbProps = { href: breadcrumb.url };
        }
      }
      return (h("se-breadcrumb-item", Object.assign({}, breadcrumbProps), h("span", { innerHTML: breadcrumb.name })));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleTailDidAppend(event) {
    this.setTailState(event.detail);
  }
  setTailState(data) {
    this.tail = (data === null || data === void 0 ? void 0 : data.length) ? [...data] : [];
  }
  componentWillLoad() {
    var _a, _b;
    this.breadcrumbs = (_a = tryParse(this._breadcrumbs)) !== null && _a !== void 0 ? _a : this.breadcrumbs;
    this.hideOnMobile = (_b = tryParse(this._hideOnMobile)) !== null && _b !== void 0 ? _b : this.hideOnMobile;
  }
  render() {
    var _a;
    if (!((_a = this.breadcrumbs) === null || _a === void 0 ? void 0 : _a.length)) {
      return null;
    }
    const breadcrumbs = [...this.breadcrumbs, ...this.tail];
    const { productCategory, productSubCategory, productRange, productName } = getProductInfoFromBreadcrumbs(this.breadcrumbs);
    return (h(Fragment, null, h("se-breadcrumb", { class: classnames('breadcrumbs', 'js-pes-sticky', {
        'breadcrumbs--hide-mobile': this.hideOnMobile,
      }), breakpoint: "desktop", withMicrodata: "true" }, breadcrumbs.map(this.getBreadcrumb)), h("pes-product-info-chat-event", { productCategory: productCategory, productSubCategory: productSubCategory, productRange: productRange, productName: productName, sendProductInfoUsingInterval: true })));
  }
  get el() { return getElement(this); }
};
Breadcrumbs.style = breadcrumbsCss;

const productCardIdCss = ":host{display:block}.card{display:flex;flex-direction:column;width:100%;text-decoration:none;color:#333333;padding:10px;box-sizing:border-box;background:var(--pes-product-card-bgcolor, inherit)}@media screen and (min-width: 980px){.card{flex-direction:row;padding:16px}}.card__img{width:150px;height:100%}@media screen and (min-width: 980px){.card__img{width:70px;flex-shrink:0}}.card__info{display:flex;flex-direction:column;overflow:hidden}@media screen and (min-width: 980px){.card__info{flex:1 1}:host(:not([dir=\"rtl\"])) .card__info{margin-left:10px}:host([dir=\"rtl\"]) .card__info{margin-right:10px}}.card__name{color:#626469;font-size:10px}.card__description{margin:7px 0;font-size:14px}@media screen and (min-width: 980px){.card__description{margin:8px 0}}";

let ProductCardId = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onClickHandler = (event) => {
      if (isAppRoutingEnabled()) {
        event.preventDefault();
        navigateWithRouter(this.route, event.currentTarget);
      }
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.productUrl);
      this.route = new PesRoute({ page: pageType, pageId });
      this.productUrl = this.route.url;
    }
  }
  render() {
    return (h("a", { href: this.productUrl, class: "card", onClick: this.onClickHandler }, h("pes-lazy-img", { class: "card__img", src: this.imageUrl, alt: this.imageTitle }), h("section", { class: "card__info" }, h("span", { class: "card__name" }, this.name), h("p", { class: "card__description" }, this.description ? h("pes-ellipsis", { maxHeight: "50px", content: this.description }) : ''))));
  }
  get el() { return getElement(this); }
};
ProductCardId.style = productCardIdCss;

const productCardIdSoftwareCss = ":host{display:block}.card{display:flex;flex-direction:column;width:100%;text-decoration:none;color:#333333;padding:10px;box-sizing:border-box;background:var(--pes-product-card-bgcolor, inherit)}@media screen and (min-width: 980px){.card{flex-direction:row;padding:16px}}:host(.mode--desktop-only) .card{flex-direction:row;padding:16px}.card__img{width:150px;height:100%}@media screen and (min-width: 980px){.card__img{width:70px;flex-shrink:0}}:host(.mode--desktop-only) .card__img{width:70px;flex-shrink:0}.card__info{display:flex;flex-direction:column;overflow:hidden}@media screen and (min-width: 980px){.card__info{flex:1 1}:host(:not([dir=\"rtl\"])) .card__info{margin-left:10px}:host([dir=\"rtl\"]) .card__info{margin-right:10px}}:host(.mode--desktop-only) .card__info{flex:1 1}:host(:not([dir=\"rtl\"]).mode--desktop-only) .card__info{margin-left:10px}:host([dir=\"rtl\"].mode--desktop-only) .card__info{margin-right:10px}.card__name{color:#626469;font-size:10px}.card__description{margin:7px 0;font-size:14px}@media screen and (min-width: 980px){.card__description{margin:8px 0}}:host(.mode--desktop-only) .card__description{margin:8px 0}.card__version{margin:0;font-size:12px;color:#626469}";

let ProductCardIdSoftware = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.noMobileView = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, { class: classnames({ 'mode--desktop-only': this.noMobileView }) }, h("a", { href: this.productUrl, class: "card" }, h("pes-lazy-img", { class: "card__img", src: this.imageUrl, alt: this.imageTitle }), h("div", { class: "card__info" }, h("span", { class: "card__name" }, this.name), h("p", { class: "card__description" }, this.description ? h("pes-ellipsis", { maxHeight: "50px", content: this.description }) : ''), this.version && (h("p", { class: "card__version" }, this.versionLabel, " ", this.version))))));
  }
  get el() { return getElement(this); }
};
ProductCardIdSoftware.style = productCardIdSoftwareCss;

let ProductInfoChatEvent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.sendProductInfoUsingInterval = false;
    this.intervalInMs = 500;
    this.dispatchChatEvent = () => {
      if (document.getElementById('chatHandler')) {
        this.sendProductInfo();
        clearInterval(this.chatInterval);
      }
    };
  }
  sendProductInfo() {
    document.getElementById('chatHandler').dispatchEvent(new CustomEvent('addProductInfo', {
      detail: {
        productCategory: this.productCategory,
        productSubCategory: this.productSubCategory,
        productRange: this.productRange,
        productName: this.productName,
      },
    }));
  }
  connectedCallback() {
    if (this.sendProductInfoUsingInterval)
      return;
    if (sessionStorage.getItem('embedded_chat_loaded')) {
      this.sendProductInfo();
    }
    else {
      document.addEventListener('chatLoaded', this.sendProductInfo);
    }
  }
  disconnectedCallback() {
    window.removeEventListener('chatLoaded', this.sendProductInfo);
  }
  componentDidLoad() {
    if (this.sendProductInfoUsingInterval) {
      this.chatInterval = setInterval(this.dispatchChatEvent, this.intervalInMs);
    }
  }
};

const productsCarouselCss = ":host{display:block}*{box-sizing:border-box}.header{color:#3dcd58;font-size:16px;margin:20px 0;font-weight:bold;line-height:1.5625rem}@media screen and (min-width: 980px){.header{font-size:28px;margin:40px auto 20px;max-width:1200px;padding:0 10px}}.header--crossSellLife{color:#b10043}.content{max-width:1200px;margin:0 -16px}@media screen and (min-width: 980px){.content{padding-bottom:45px}}@media screen and (min-width: 1230px){.content{margin:0 auto}}.collapsible-container{background-color:#f7f7f7}.product__white{background-color:white}:host(:not([dir=\"rtl\"])) .product{margin-right:10px}:host([dir=\"rtl\"]) .product{margin-left:10px}@media screen and (max-width: 719px){.product{--se-carousel-item-width:calc(\n        (100% - 10px) / 2\n      )}}@media screen and (min-width: 720px) and (max-width: 980px){.product{--se-carousel-item-width:calc(\n        (100% - 20px) / 3\n      )}}@media screen and (min-width: 980px){.product{--se-carousel-item-width:calc(\n        (100% - 60px) / 4\n      )}}@media screen and (max-width: 1229px){:host(:not([dir=\"rtl\"])) .product:first-child{padding-left:16px}:host([dir=\"rtl\"]) .product:first-child{padding-right:16px}:host(:not([dir=\"rtl\"])) .product:last-child{padding-right:16px}:host([dir=\"rtl\"]) .product:last-child{padding-left:16px}}:host(:not([dir=\"rtl\"])) .product:last-child{margin-right:0}:host([dir=\"rtl\"]) .product:last-child{margin-left:0}@media screen and (min-width: 980px){.product{height:140px}:host(:not([dir=\"rtl\"])) .product{margin-right:20px}:host([dir=\"rtl\"]) .product{margin-left:20px}}";

let ProductsCarousel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.setTabActive = createEvent(this, "setTabActive", 7);
    this.isBackgroundGrey = false;
    this.ref = null;
    this.screenSizeHandler = () => {
      this.arrowsOverlay = !this.mql.matches;
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getMapping(type) {
    const stickyBarMapping = {
      [ECarouselRelation.Compatiblesoftware]: ETabType.SOFTWARE_CAROUSEL,
      [ECarouselRelation.crossSellLife]: ETabType.LIFECYCLE_CAROUSEL,
      [ECarouselRelation.upsell]: ETabType.EXPLORE_CAROUSEL,
      [ECarouselRelation.crosssell]: ETabType.FREQUENTLY_BOUGHT_CAROUSEL,
    };
    return stickyBarMapping[type];
  }
  setupTabbar() {
    const tabtype = this.getMapping(this.relationType);
    if (tabtype) {
      setStickyBarTab(tabtype, [this.sectionTitle]);
      this.observe();
    }
  }
  handleTabClicked(event) {
    if (this.ref && event.detail.title === this.sectionTitle) {
      scrollToComponent(this.ref);
    }
  }
  observe() {
    observeIntersectionWithHeader(this.ref, (entries) => {
      var _a;
      if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
        const tabtype = this.getMapping(this.relationType);
        setTabActive({ type: tabtype, title: this.sectionTitle });
        this.setTabActive.emit();
      }
    });
  }
  componentWillLoad() {
    var _a, _b, _c, _d;
    this.sectionTitle = (_a = tryParse(this._sectionTitle)) !== null && _a !== void 0 ? _a : this.sectionTitle;
    this.data = (_b = tryParse(this._data)) !== null && _b !== void 0 ? _b : this.data;
    this.versionLabel = (_c = tryParse(this._versionLabel)) !== null && _c !== void 0 ? _c : this.versionLabel;
    this.relationType = (_d = tryParse(this._relationType)) !== null && _d !== void 0 ? _d : this.relationType;
  }
  componentDidLoad() {
    const screenSize = DESKTOP_MAX_CONTENT_WIDTH + 100;
    this.mql = window.matchMedia(`screen and (min-width: ${screenSize}px)`);
    this.arrowsOverlay = !this.mql.matches;
    {
      this.mql.addListener(this.screenSizeHandler);
    }
    this.setupTabbar();
  }
  disconnectedCallback() {
    this.mql.removeListener(this.screenSizeHandler);
  }
  render() {
    var _a;
    if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length)) {
      return null;
    }
    return (h("pes-collapsible-container", { class: this.isBackgroundGrey && 'collapsible-container', ref: (el) => (this.ref = el) }, h("h2", { slot: "header", class: Object.assign({ header: true }, (this.relationType && { [`header--${this.relationType}`]: true })) }, this.sectionTitle), h("div", { class: "content" }, h("se-carousel", { "item-min-width": 0, hintWidth: 0, arrowsOverlay: this.arrowsOverlay, pagination: true }, this.data.map((product) => (h("se-carousel-item", { class: "product" }, h("div", { class: {
        product__card: true,
        product__white: this.isBackgroundGrey,
      } }, product.softwareType ? (h("pes-product-card-id-software", Object.assign({}, product, { versionLabel: this.versionLabel, key: product.name }))) : (h("pes-product-card-id", Object.assign({}, product, { key: product.name })))))))))));
  }
  get el() { return getElement(this); }
};
ProductsCarousel.style = productsCarouselCss;

export { Breadcrumbs as pes_breadcrumbs, ProductCardId as pes_product_card_id, ProductCardIdSoftware as pes_product_card_id_software, ProductInfoChatEvent as pes_product_info_chat_event, ProductsCarousel as pes_products_carousel };
